import { Customizations } from 'models'

const saleResultVehiclesTableLabels: Customizations = {
  passingOrderNo: {
    label: 'Ord.',
    isDisplayed: true,
  },
  no: {
    label: 'Réf.',
    isDisplayed: true,
  },
  licensePlate: {
    label: 'Immat.',
    isDisplayed: true,
  },
  type: {
    label: 'Ge',
    isDisplayed: true,
  },
  version: {
    label: 'Type Commercial',
    isDisplayed: true,
  },
  color: {
    label: 'Coul',
    isDisplayed: true,
  },
  dateFirstReg: {
    label: 'MEC',
    isDisplayed: true,
  },
  mileage: {
    label: 'KM',
    isDisplayed: true,
  },
  coteArgusPriceDate: {
    label: 'CD',
    isDisplayed: true,
  },
  coteArgusKm: {
    label: 'CK',
    isDisplayed: true,
  },
  nbPassage: {
    label: 'NP',
    isDisplayed: true,
  },
  withdrawalPrice: {
    label: 'Prix retrait',
    isDisplayed: true,
  },
  estimationApporteur: {
    label: 'Estimation',
    isDisplayed: true,
  },
  bidPrice: {
    label: 'Adjudication',
    isDisplayed: true,
  },
  tvaRecuperable: {
    label: 'TVA',
    isDisplayed: true,
  },
  observationsVendeur: {
    label: 'Observat°',
    isDisplayed: true,
  },
}

export { saleResultVehiclesTableLabels }
